// Collection filter drawer
if (document.querySelector('.js-collection-filter__open')) {
  const collection_grid = document.getElementById('CollectionProductGrid');
  const filter_drawer = document.querySelector('.js-collection-filter');
  const filter_open = document.querySelector('.js-collection-filter__open');
  const filter_close = document.querySelector('.js-collection-filter__close');

  let config = { attributes: true, subtree: true };
  let observer = new MutationObserver((mutations)=> {
    let open = document.querySelector('.js-collection-filter__open');
    let openDrawer = function() {
      document.querySelector('.js-collection-filter').classList.add('h9--collection-filter--open');
      document.body.classList.add('slideout-right--open');
    };
    open.removeEventListener('click', openDrawer);
    open.addEventListener('click', openDrawer);
  });
  observer.observe(collection_grid, config);

  filter_open.addEventListener('click', (e) => {
    filter_drawer.classList.add('h9--collection-filter--open');
    document.body.classList.add('slideout-right--open');
  });
  filter_close.addEventListener('click', (e) => {
    filter_drawer.classList.remove('h9--collection-filter--open');
    document.body.classList.remove('slideout-right--open');
  });

  // Collection filter accordions
  const filterAccordionButtons = Array.from(document.querySelectorAll('.js-filter-accordion-button'));
  const filterAccordions = Array.from(document.querySelectorAll('.js-filter-accordion'));

  for (let i = 0, limit = filterAccordionButtons.length; i < limit; i++) {
    filterAccordionButtons[i].addEventListener('click', (e) => {
      if (e.target.tagName !== 'A') {
        let i = filterAccordionButtons.indexOf(e.target.closest('.js-filter-accordion-button'));
        if (filterAccordions[i].classList.contains('h9--filter-accordion--close')) {
          filterAccordionButtons[i].querySelector('.h9--filter__plus').classList.add('hidden');
          filterAccordionButtons[i].querySelector('.h9--filter__minus').classList.remove('hidden');
          filterAccordions[i].classList.remove('h9--filter-accordion--close');
        } else {
          filterAccordionButtons[i].querySelector('.h9--filter__plus').classList.remove('hidden');
          filterAccordionButtons[i].querySelector('.h9--filter__minus').classList.add('hidden');
          filterAccordions[i].classList.add('h9--filter-accordion--close');
        }
      }
    })
  }
}

// Collection descriptions
if (document.querySelector('.collection-description')) {
  const collectionDescriptions = Array.from(document.querySelectorAll('.collection-description'));
  const readMoreBtns = Array.from(document.querySelectorAll('.js-collection-read-more'));

  collectionDescriptions.forEach((el, index)=>{
      if (el.scrollHeight == el.clientHeight && el.clientHeight > 0) {
          collectionDescriptions[index].classList.remove('collection-description--truncate');
          readMoreBtns[index].classList.add('hidden');
      }
  });

  readMoreBtns.forEach((el, index)=>{
      el.addEventListener('click', (e)=>{
          collectionDescriptions[index].classList.remove('collection-description--truncate');
          readMoreBtns[index].classList.add('hidden');
      });
  });
}

$(document).on('click', '.video__play', function () {
   $(this).closest('.video-image-section').addClass('video-is-playing');
   var video_id = $(this).closest('.video-image-section').find('iframe').attr('id');
   $("#"+video_id)[0].src += "&autoplay=1";
});

$(document).on('click', '.video-close-wrapper', function () {
   $(this).closest('.video-image-section').removeClass('video-is-playing');
  var video_id = $(this).closest('.video-image-section').find('iframe').attr('id');
   var videoURL = $('#'+video_id).prop('src');
    videoURL = videoURL.replace("&autoplay=1", "");
    $('#'+video_id).prop('src','');
    $('#'+video_id).prop('src',videoURL);
   
   //$("#"+video_id)[0].src += "&autoplay=0";
});